//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
export default {
    data () {
        return {
            sqspf_url: "https://sqspf.cdzj.chengdu.gov.cn/advancedmanpurchaseapply"
        }
    },
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/personal_package/qa/main')
        const option = {
            title: `${process.env.APP_NAME}-常见问题`,
            path: `/index/main?sub_page=${sub_page}`
        }
        return this.getShareInfo(option)
    },
    methods: {
        handle () {
            const url = document.querySelector('#sqspf_url')
            url.select()
            document.execCommand('Copy')
            url.blur()
            this.$wx.showToast({
                title: '复制成功'
            })
        }
    }
}
